const Builder = require('../BuilderBase');

module.exports = class ThumbnailColumn extends Builder {
    constructor(title, properties) {
        super('listColumn_Thumbnail', title, properties);
        if (!properties || !properties.propertyName) {
            throw new Error(
                `${title} does not have a 'propertyName'.  You must pass a 'propertyName' value in properties when creating a thumbnail column.`
            );
        }
    }
};
